import { PricingList } from '@micro-apps/stores';
import Dialog, { Props as DialogProps } from '../Dialog/Dialog';
import { translate } from '@micro-apps/env';
import { ReactElement } from 'react';
import PriceListContent from './PriceListContent';

type Props = {
	dialog: any;
	pricingList?: PricingList;
	pricingListDisclaimer?: string | null;
	dialogClassName?: string;
	headerSlot?: ReactElement;
} & DialogProps;

const PriceListDialog = ({
	dialog,
	pricingList,
	pricingListDisclaimer,
	dialogClassName,
	headerSlot,
	...rest
}: Props) => {
	return (
		<Dialog
			title={translate('Price List')}
			{...rest}
			dialogRef={instance => {
				dialog.current = instance;
			}}
			className="Warningmodal-content price-listing-modal"
			classNames={{
				container: 'Dialog hidden',
				overlay: 'Dialog-overlay',
				dialog: `Dialog-wrapper pricing-list-modal ${dialogClassName}`,
				title: 'Dialog-title title',
				closeButton: 'Dialog-closebutton',
			}}
			maxWrapperHeightToContent
			disableScroll
		>
			<PriceListContent pricingList={pricingList} pricingListDisclaimer={pricingListDisclaimer} />
		</Dialog>
	);
};

export default PriceListDialog;
